// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__6VUv7","title":"InfoRow_title__3kBqn"};